var map = {
	"./Jupiter.svg": 1410,
	"./Mars.svg": 1411,
	"./Mercury.svg": 1412,
	"./Moon.svg": 1413,
	"./Neptune.svg": 1414,
	"./Pluto.svg": 1415,
	"./Saturn.svg": 1416,
	"./The Sun.svg": 1417,
	"./Uranus.svg": 1418,
	"./Venus.svg": 1419
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1409;


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet ^\.\/.*\.svg$
// module id = 1409
// module chunks = 0